<template>
  <Content title="角色管理">
    <template v-slot:content>
      <div class="role-group-list">
        <div
          class="role-group"
          v-for="(roleList, groupIndex) in roleGroupList"
          :key="groupIndex"
        >
          <template v-for="role in roleList">
            <div
              class="role role-panel"
              v-if="role !== ROLE_ADD"
              :key="role.id"
            >
              <div class="role__content">
                <div class="role__info">
                  <div class="role__title">{{ role.roleName }}</div>
                  <div class="role__desc">{{ role.productName }}</div>
                </div>
              </div>
              <div class="role__footer">
                <div class="role__action-list">
                  <span
                    class="role__action role__action--perm"
                    @click="handleClickSet(role)"
                  >编辑</span>
                  <a-popconfirm
                    @confirm="handleDelete(role.id)"
                    placement="bottom"
                  >
                    <template slot="title">
                      <div class="confirm-title">确认要删除这个角色吗？</div>
                      <div class="confirm-desc">删除后请将该角色下的所有账号角色归属将失效，请重新设置。</div>
                    </template>
                    <span class="role__action role__action--del">删除</span>
                  </a-popconfirm>
                </div>
              </div>
            </div>
            <div
              class="role role--add role-panel"
              @click="handleClickAdd(role)"
              :key="role"
              v-else
            >
              <div class="role__title role--add__title"><a-icon
                type="plus"
                class="role--add__icon"
              /> 新增角色</div>
            </div>
          </template>
        </div>
      </div>
    </template>
    <aside>
      <EditModal
        v-if="showEditModal"
        :visible="showEditModal"
        :role="editingRole"
        @ok="handleEdit"
        @cancel="handleEditCancel"
      />
    </aside>
  </Content>
</template>

<script>
import { mapState } from 'vuex';
import Content from '@/components/Content';
import { groupBySum } from '@/utils/helpers';
import EditModal from './edit-modal';

const ROLE_COUNT_PER_LINE = 4;
const ROLE_ADD = 'ROLE_ADD';

export default {
  components: {
    Content,
    EditModal,
  },
  data() {
    return {
      ROLE_COUNT_PER_LINE,
      ROLE_ADD,
      showEditModal: false,
      editingRole: null,
    };
  },
  computed: {
    ...mapState('role', ['roleList']),
    roleGroupList() {
      return groupBySum([...this.roleList, ROLE_ADD], ROLE_COUNT_PER_LINE);
    },
  },
  methods: {
    handleEdit(values) {
      const { editingRole } = this;
      const payload = { ...values };
      let eventType;

      if (editingRole) {
        eventType = 'role/edit';
        payload.id = editingRole.id;
      } else {
        eventType = 'role/add';
      }
      
      this.$store.dispatch(eventType, payload)
        .then(() => {
          this.$message.success('操作成功');
          this.showEditModal = false;
          this.loadData();
        });
    },
    handleEditCancel() {
      this.showEditModal = false;
    },
    handleDelete(id) {
      this.$store.dispatch('role/del', { id })
        .then(() => this.loadData());
    },
    handleClickAdd() {
      this.editingRole = null;
      this.showEditModal = true;
    },
    handleClickSet(role) {
      this.editingRole = role;
      this.showEditModal = true;
    },
    loadData() {
      this.$store.dispatch('role/fetchList');
    },
  },
  created() {
    this.loadData();
  },
};
</script>

<style lang="less" scoped>
.role-panel {
  // padding: 32px 24px;
  border-radius: 2px;
  line-height: 1;
}

.role {
  display: flex;
  flex: 0 1 (100% / 4);
  flex-direction: column;
  // justify-content: space-between;
  margin: 12px;
  border: 1px dashed transparent;
  background-color: var(--card-bg);
  box-shadow: 0 6px 16px 1px rgba(0, 0, 0, .08);

  &__content {
    padding: 24px;
  }

  &__footer {
    margin-top: 16px;
    border-top: 1px solid var(--border-color-split);
  }

  &__action {
    flex: 1 0 0;
    text-align: center;
    cursor: pointer;

    &:not(:last-child) {
      border-right: 1px solid var(--border-color-split);
    }

    &-list {
      display: flex;
      padding: 16px;
      line-height: 24px;
      background-color: var(--card-bg);
    }
  }

  &__title {
    font: 500 16px PingFangSC-Medium;
    color: --text-color;
  }

  &__desc {
    margin-top: 16px;
    font: 400 14px / 20px PingFangSC-Regular;
    color: var(--text-color-secondary);
  }

  &--add {
    justify-content: center;
    text-align: center;
    cursor: pointer;
    border-color: var(--main-color);

    &__title, &__icon {
      color: var(--main-color);
    }

    &:only-child {
      padding: 24px 32px;
    }
  }

  &-group {
    display: flex;
    align-items: stretch;
  }
}
</style>
